import styled from 'styled-components';

import { basicBodyTextStyle, fonts } from '@dreryk/react-components';

export const StyledCheckboxContent = styled.div`
   display: block;
`;

export const StyledCheckboxName = styled.div`
   ${basicBodyTextStyle};
   font-weight: ${fonts.fontWeightBold};
`;

export const StyledCheckboxList = styled.ul`
   list-style: none;
   margin: 0;
   padding: 0;

   > li:after {
      content: ',';
   }
   > li:last-child:after {
      content: '';
   }
`;
